import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './components/ui/dialog';
import { Button } from './components/ui/button';
import { X, Download, ZoomIn, ZoomOut } from 'lucide-react';

const ImageViewerModal = ({ isOpen, onClose, imageUrl, title, onDownload }) => {
  const [zoom, setZoom] = React.useState(100);

  const handleZoomIn = () => {
    setZoom(prev => Math.min(prev + 25, 300));
  };

  const handleZoomOut = () => {
    setZoom(prev => Math.max(prev - 25, 50));
  };

  const resetZoom = () => {
    setZoom(100);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        className="max-w-5xl max-h-[90vh] w-full p-0 image-modal-mobile flex flex-col overflow-hidden"
        style={{ zIndex: 9999 }}
      >
        <DialogHeader 
          className="p-4 border-b flex flex-row items-center justify-between flex-shrink-0 bg-white"
          style={{ position: 'sticky', top: 0, zIndex: 10 }}
        >
          <DialogTitle className="text-lg font-semibold truncate flex-1">
            {title || 'Visualizar Imagem'}
          </DialogTitle>
          <div className="flex items-center gap-2">
            {/* Controles de Zoom */}
            <div className="flex items-center gap-1 border rounded px-2 py-1">
              <Button
                variant="ghost"
                size="sm"
                onClick={handleZoomOut}
                className="h-7 w-7 p-0"
                title="Diminuir zoom"
              >
                <ZoomOut className="h-4 w-4" />
              </Button>
              <span className="text-xs font-medium min-w-[45px] text-center">{zoom}%</span>
              <Button
                variant="ghost"
                size="sm"
                onClick={handleZoomIn}
                className="h-7 w-7 p-0"
                title="Aumentar zoom"
              >
                <ZoomIn className="h-4 w-4" />
              </Button>
            </div>
            
            <Button
              variant="outline"
              size="sm"
              onClick={resetZoom}
              className="text-xs px-2 py-1"
            >
              Reset
            </Button>
            
            {onDownload && (
              <Button
                variant="outline"
                size="sm"
                onClick={onDownload}
                className="flex items-center gap-1"
              >
                <Download className="h-4 w-4" />
                Download
              </Button>
            )}
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="h-8 w-8 p-0"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </DialogHeader>
        
        <div className="flex-1 overflow-auto bg-gray-100 p-4" style={{ maxHeight: 'calc(90vh - 80px)' }}>
          {imageUrl ? (
            <div className="flex items-center justify-center min-h-full">
              <img
                src={imageUrl}
                alt={title || 'Attachment'}
                className="max-w-full h-auto shadow-lg rounded-lg bg-white"
                style={{ 
                  transform: `scale(${zoom / 100})`,
                  transition: 'transform 0.2s ease',
                  transformOrigin: 'center center'
                }}
                onLoad={() => {
                  console.log('✅ Imagem carregada no modal');
                }}
                onError={() => {
                  console.error('❌ Erro ao carregar imagem');
                }}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center h-full">
              <p className="text-gray-500">Carregando imagem...</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImageViewerModal;